import { useState, useEffect } from 'react';
import { RolesApi } from '@/api/clients/roles/roles.api';

export const useGetRole = (roleId) => {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRole = async () => {
    if (!roleId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const response = await RolesApi.getRole(roleId);
      setRole(response.data.data?.role);
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || 'Failed to fetch role';
      setError(errorMessage);
      console.error('Error fetching role:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRole();
  }, [roleId]);

  const refetch = () => {
    fetchRole();
  };

  return {
    role,
    loading,
    error,
    refetch,
  };
};
